import dayjs from 'dayjs';

export const sortByDate = (objectA, objectB, field, isDesc) =>
  dayjs(objectA[field])[isDesc ? 'isBefore' : 'isAfter'](objectB[field]);
